import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';

@JsonObject('DocusignInfo')
export class DocusignInfo extends AbstractModel {

    @JsonProperty(String, 'url')
    url?: string;
}